import { render, staticRenderFns } from "./PRO_ByProvider.vue?vue&type=template&id=95bea196&scoped=true&"
import script from "./PRO_ByProvider.vue?vue&type=script&lang=js&"
export * from "./PRO_ByProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bea196",
  null
  
)

export default component.exports